var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowFatLinesDown = function SvgIconArrowFatLinesDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.75a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1M6.5 6.75a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 9.75a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v2H21a1 1 0 0 1 .707 1.707l-9 9a1 1 0 0 1-1.414 0l-9-9A1 1 0 0 1 3 11.75h3.5zm2 1v2a1 1 0 0 1-1 1H5.414L12 20.336l6.586-6.586H16.5a1 1 0 0 1-1-1v-2z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArrowFatLinesDown;